function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-603d023e-20a7-4a24-9dce-3e9978f52642",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m26.752,6.828h-11.416c-.832,0-1.506-.674-1.506-1.506s.674-1.506,1.506-1.506h11.416c.832,0,1.506.674,1.506,1.506s-.674,1.506-1.506,1.506Z",
    style: {
      fill: "#d8d8d8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.752,17.541H5.248c-.832,0-1.506-.674-1.506-1.506s.674-1.506,1.506-1.506h21.503c.832,0,1.506.674,1.506,1.506s-.674,1.506-1.506,1.506Z",
    style: {
      fill: "#d8d8d8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "8.106 3.747 3.742 11.277 12.469 11.277 8.106 3.747",
    style: {
      fill: "#d8d8d8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.752,28.253H5.248c-.832,0-1.506-.674-1.506-1.506s.674-1.506,1.506-1.506h21.503c.832,0,1.506.674,1.506,1.506s-.674,1.506-1.506,1.506Z",
    style: {
      fill: "#d8d8d8"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuUp);
export default __webpack_public_path__ + "static/media/MenuUp.ddccbcedfe7a9453b3d129a9dc6d9906.svg";
export { ForwardRef as ReactComponent };